<template>
  <div :class="classObject()">
    <button
      v-if="mode !== 'thanks'"
      type="button"
      role="button"
      aria-label="Close"
      class="modal__button-close button-close"
      @click="$emit('close')"
    >
      <cross-svg />
    </button>
    <div class="container">
      <div class="modal__wrapper">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
import CrossSvg from '../../../../../assets/img/icons/cross.svg';

export default {
  name: 'popup',
  components: {
    CrossSvg,
  },
  props: {
    mode: String,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    classObject() {
      return {
        modal: true,
        'modal--theme': this.mode === 'theme' || !this.mode,
        'modal--thanks': this.mode === 'thanks',
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;

  &--theme {
    &::before {
      background: rgba(227, 215, 203, 0.95);
    }
  }

  &--thanks {
    &::before {
      background-color: $c-light-gray;
    }
  }

  &::before {
    @include pseudo();
    top: -10%;
    left: -10%;
    z-index: -1;
    width: 120%;
    height: 120%;
  }

  &__button-close {
    position: absolute;
    top: 13px;
    right: 13px;
    padding: 10px;
    width: 40px;
    height: 40px;

    @include up-tablet {
      top: 30px;
      right: 31px;
    }
  }

  .container,
  &__wrapper {
    height: 100%;
  }

  &__wrapper {
    display: flex;
  }
}
</style>
